import type { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";

export interface Tab { id: string; label: ReactNode; count?: number }

/** Tabs whose selection lives in the URL (?tab=), so a tab can be linked to,
 *  survives reload, and the back button works. */
export function useTab(tabs: Tab[], param = "tab") {
  const [params, setParams] = useSearchParams();
  const current = tabs.find((t) => t.id === params.get(param))?.id ?? tabs[0].id;
  const set = (id: string) => {
    const next = new URLSearchParams(params);
    if (id === tabs[0].id) next.delete(param); else next.set(param, id);
    setParams(next, { replace: true });
  };
  return [current, set] as const;
}

export function Tabs({ tabs, current, onChange }: { tabs: Tab[]; current: string; onChange: (id: string) => void }) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map((t) => (
        <button key={t.id} role="tab" aria-selected={t.id === current} className="tab" onClick={() => onChange(t.id)}>
          {t.label}
          {t.count != null && <span className="tab-count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
